import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=2dbf89d3&scoped=true&"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js&"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js&"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=2dbf89d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf89d3",
  null
  
)

export default component.exports